import { AmplifyError } from './AmplifyError.mjs'; // Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var createAssertionFunction = function createAssertionFunction(errorMap) {
  var AssertionError = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : AmplifyError;
  return function (assertion, name, additionalContext) {
    var _errorMap$name = errorMap[name],
        message = _errorMap$name.message,
        recoverySuggestion = _errorMap$name.recoverySuggestion;

    if (!assertion) {
      throw new AssertionError({
        name: name,
        message: additionalContext ? "".concat(message, " ").concat(additionalContext) : message,
        recoverySuggestion: recoverySuggestion
      });
    }
  };
};

export { createAssertionFunction };